import { TutorialDefinition } from '../../../types/tutorial';
import { getModifierKey } from '../../../utils/platform';

const modKey = getModifierKey();

export const transcriptEditingTutorial: TutorialDefinition = {
  id: 'transcript-editing',
  initialAnimation: 'bottom',
  steps: [
    {
      id: 'transcript-ready',
      title: 'Transcript ready!',
      content:
        '<p>Your file has been transcribed! Now you can edit the transcript, manage speakers, and search through the content.</p>',
      placement: 'center',
    },
    {
      id: 'click-to-play',
      targetSelector: '[data-tutorial="utterance-content"]',
      title: 'Click to jump',
      content: `<p>Click on any word in the transcript to jump to that moment in the media.</p>
        <p><strong>Hotkeys:</strong></p>
        <ul>
          <li><strong>Tab</strong> - start/pause playing</li>
        </ul>`,
      placement: 'right',
      offsetX: 10,
    },
    {
      id: 'edit-text',
      targetSelector: '[data-tutorial="utterance-content"]',
      title: 'Edit text',
      content: `<p>Click on any text to edit it. Your changes are automatically saved.</p>
        <p><strong>Hotkeys:</strong></p>
        <ul>
          <li><strong>Enter</strong> - split utterance</li>
          <li><strong>Backspace</strong> at the beginning - merge with previous utterance</li>
        </ul>`,
      placement: 'right',
      offsetX: 10,
    },
    {
      id: 'speaker-labels',
      targetSelector: '[data-tutorial="speaker-label"]',
      title: 'Manage speakers',
      content:
        "<p>Click on speaker name to change this utterance's speaker.</p>",
      placement: 'left',
      offsetX: -10,
    },
    {
      id: 'search-navigator',
      targetSelector: '[data-tutorial="search-navigator"]',
      title: 'Search your transcript',
      content: `<p>Use the search feature to find specific words or phrases in your transcript.</p>
        <p><strong>Hotkeys:</strong></p>
        <ul>
          <li><strong>Enter</strong> - navigate forward</li>
          <li><strong>Shift+Enter</strong> - go backward</li>
        </ul>`,
      placement: 'top',
      offsetY: 10,
    },
    {
      id: 'low-confidence',
      targetSelector: '[data-tutorial="low-confidence-navigator"]',
      title: 'Review low confidence words',
      content: `<p>Words with low confidence are highlighted.</p>
        <p><strong>Hotkeys:</strong></p>
        <ul>
          <li><strong>Enter</strong> - move to the next word</li>
          <li><strong>Shift+Enter</strong> - move to the previous word</li>
        </ul>`,
      placement: 'top',
      offsetY: 10,
    },
    {
      id: 'undo-redo',
      targetSelector: '[data-tutorial="undo-redo-toolbar"]',
      title: 'Undo and redo',
      content: `<p>Use these buttons to undo or redo your edits.</p>
        <p><strong>Keyboard shortcuts:</strong></p>
        <ul>
          <li><strong>${modKey}+Z</strong> - undo</li>
          <li><strong>${modKey}+Shift+Z</strong> - redo</li>
        </ul>`,
      placement: 'top',
      offsetY: 10,
    },
  ],
};
